// extracted by mini-css-extract-plugin
export default {"custom":"custom_custom__7nPTd","active":"custom_active__oHoL7","disabled":"custom_disabled__y7q8u","tabs":"custom_tabs__fVNxe","loader":"custom_loader__wgmVJ"};